import { useRegisterHeightToCSS } from "@/hooks/useRegisterHeightToCSS";
import useAppStore from "@/store/app-store";
import { ChevronDown, Menu } from "@pkg/icons";
import { useRef } from "react";
import type { ResolvedNavConfig } from "./types";
import {
  NavBackButton,
  NavLinkItem,
  NavLinks,
  NavLogo,
  NavMobileMenu,
  NavShell,
} from "./ui";

const Navbar: React.FC<ResolvedNavConfig> = ({
  dark,
  sticky,
  onLogoClick,
  backButton,
  tabs,
  resourcesDropdown,
  rightSlot,
  showHamburger,
  showMobileMenu,
  isPhotonFlow,
}) => {
  const navRef = useRef<HTMLDivElement>(null);
  useRegisterHeightToCSS(navRef, "--top-nav-height");

  const isMobileMenuShow = useAppStore((state) => state.isMobileMenuShow);
  const setIsMobileMenuShow = useAppStore((state) => state.setIsMobileMenuShow);
  const toggleMobileMenu = () => setIsMobileMenuShow(!isMobileMenuShow);

  return (
    <NavShell ref={navRef} sticky={sticky} dark={dark}>
      {backButton && <NavBackButton onClick={backButton.onClick} />}

      <div className="flex items-center gap-14">
        <NavLogo dark={dark} onClick={onLogoClick} />

        {/* Desktop tabs */}
        {tabs && (
          <NavLinks className="hidden lg:flex">
            {tabs.map((item) => (
              <NavLinkItem
                key={item.title}
                href={item.href}
                external={item.external}
                badge={item.badge}
                active={item.active}
                onClick={item.onClick}
              >
                {item.title}
              </NavLinkItem>
            ))}

            {/* Resources dropdown (logged-out) */}
            {resourcesDropdown && (
              <div className="group relative">
                <NavLinkItem className="flex items-center gap-1">
                  Resources
                  <ChevronDown size={16} />
                </NavLinkItem>
                <div className="absolute top-full left-0 z-50 hidden min-w-55 flex-col gap-1 space-y-1 bg-surface-1 px-5 py-5 text-xl shadow-xl group-hover:flex">
                  {resourcesDropdown.map((item) => (
                    <NavLinkItem
                      key={item.title}
                      href={item.href}
                      external
                      className="px-2 py-1 text-sm text-white hover:text-cornflowerBlue"
                    >
                      {item.title}
                    </NavLinkItem>
                  ))}
                </div>
              </div>
            )}
          </NavLinks>
        )}
      </div>

      {/* Right slot */}
      {rightSlot && (
        <div className="hidden items-center gap-1 sm:flex">{rightSlot}</div>
      )}

      {/* Mobile hamburger */}
      {showHamburger && (
        <button
          className="flex items-center sm:hidden"
          onClick={toggleMobileMenu}
        >
          <Menu className="h-6 w-6 cursor-pointer text-white" />
        </button>
      )}

      {/* Mobile menu */}
      {showMobileMenu && (
        <NavMobileMenu
          isOpen={isMobileMenuShow}
          onClose={toggleMobileMenu}
          isPhotonFlow={isPhotonFlow}
        />
      )}
    </NavShell>
  );
};

export default Navbar;
